<template>
  <section class="section">
    <img class="leaf-1" src="@/assets/images/leaves/l2.png"/>
    <div class="container items-center">
      <h3 class="section__h3 mb-5">Cookie Policy for GetBoarded</h3>
      <p class="section__p mb-base">This is the Cookie Policy for GetBoarded, accessible from www.getboarded.com, www.getboarded.tech, getboarded.com, getboarded.tech</p>
      <img class="leaf-2" src="@/assets/images/leaves/l7.png"/>
      <div>
        <vx-card class="w-9/12 mb-base items-left" title="What Are Cookies" no-shadow card-background="#F7F8F9">
          <p class="mb-5">As is common practice with almost all professional websites this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it and why we sometimes need to store these cookies. We will also share how you can prevent these cookies from being stored however this may downgrade or 'break' certain elements of the sites functionality.</p>
          <p>For more general information on cookies see the Wikipedia article on HTTP Cookies.</p>
        </vx-card>

        <vx-card class="w-9/12 mb-base items-left" title="How We Use Cookies" no-shadow card-background="#F7F8F9">
          <p class="mb-5">We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.</p>
        </vx-card>

        <vx-card class="w-9/12 mb-base items-left" title="Disabling Cookies" no-shadow card-background="#F7F8F9">
          <p class="mb-5">You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of the this site. Therefore it is recommended that you do not disable cookies.</p>
        </vx-card>

        <vx-card class="w-9/12 mb-base items-left" title="The Cookies We Set" no-shadow card-background="#F7F8F9">
          <span class="font-bold">Account related cookies</span>
            <p class="mb-5">If you create an account with us then we will use cookies for the management of the signup process and general administration. These cookies will usually be deleted when you log out however in some cases they may remain afterwards to remember your site preferences when logged out.</p>

          <span class="font-bold">Login related cookies</span>

          <p class="mb-5">We use cookies when you are logged in so that we can remember this fact. This prevents you from having to log in every single time you visit a new page. These cookies are typically removed or cleared when you log out to ensure that you can only access restricted features and areas when logged in.</p>

            <span class="font-bold">Email newsletters related cookies</span>
          <p class="mb-5">This site offers newsletter or email subscription services and cookies may be used to remember if you are already registered and whether to show certain notifications which might only be valid to subscribed/unsubscribed users.</p>

            <span class="font-bold">Forms related cookies</span>
          <p class="mb-5">When you submit data to through a form such as those found on contact pages or comment forms cookies may be set to remember your user details for future correspondence.</p>

            <span class="font-bold">Site preferences cookies</span>

          <p>In order to provide you with a great experience on this site we provide the functionality to set your preferences for how this site runs when you use it. In order to remember your preferences we need to set cookies so that this information can be called whenever you interact with a page is affected by your preferences.</p>
        </vx-card>

        <vx-card class="w-9/12 mb-base items-left" title="Third Party Cookies" no-shadow card-background="#F7F8F9">
          <p class="mb-5">In some special cases we also use cookies provided by trusted third parties. The following section details which third party cookies you might encounter through this site.</p>
          <p class="mb-5">This site uses Google Analytics which is one of the most widespread and trusted analytics solution on the web for helping us to understand how you use the site and ways that we can improve your experience. These cookies may track things such as how long you spend on the site and the pages that you visit so we can continue to produce engaging content.
            For more information on Google Analytics cookies, see the official Google Analytics page.</p>

          <p class="mb-5">Third party analytics are used to track and measure usage of this site so that we can continue to produce engaging content. These cookies may track things such as how long you spend on the site or pages you visit which helps us to understand how we can improve the site for you.</p>

          <p class="mb-5">From time to time we test new features and make subtle changes to the way that the site is delivered. When we are still testing new features these cookies may be used to ensure that you receive a consistent experience whilst on the site whilst ensuring we understand which optimisations our users appreciate the most.</p>

          <p class="mb-5">As we sell products it's important for us to understand statistics about how many of the visitors to our site actually make a purchase and as such this is the kind of data that these cookies will track. This is important to you as it means that we can accurately make business predictions that allow us to monitor our advertising and product costs to ensure the best possible price.</p>

          <p class="mb-5">The Google AdSense service we use to serve advertising uses a DoubleClick cookie to serve more relevant ads across the web and limit the number of times that a given ad is shown to you.
            For more information on Google AdSense see the official Google AdSense privacy FAQ.</p>

          <p class="mb-5">We use adverts to offset the costs of running this site and provide funding for further development. The behavioural advertising cookies used by this site are designed to ensure that we provide you with the most relevant adverts where possible by anonymously tracking your interests and presenting similar things that may be of interest.</p>

          <p class="mb-5">Several partners advertise on our behalf and affiliate tracking cookies simply allow us to see if our customers have come to the site through one of our partner sites so that we can credit them appropriately and where applicable allow our affiliate partners to provide any bonus that they may provide you for making a purchase.</p>

          <p class="mb-5">We also use social media buttons and/or plugins on this site that allow you to connect with your social network in various ways. For these to work the following social media sites including; {List the social networks whose features you have integrated with your site?:12}, will set cookies through our site which may be used to enhance your profile on their site or contribute to the data they hold for various purposes outlined in their respective privacy policies.</p>
        </vx-card>

        <vx-card class="w-9/12 mb-base items-left" title="More Information" no-shadow card-background="#F7F8F9">
          <p class="mb-5">Hopefully that has clarified things for you and as was previously mentioned if there is something that you aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact with one of the features you use on our site. This Cookies Policy was created with the help of the Generator of <span class="text-primary"><a href="#">GDPR Cookies Policy Template</a></span> and the <span class="text-primary"><a href="#">GDPR Cookies Policy Template</a></span> based on the <span class="text-primary"><a href="#">Privacy Policy Generator from TermsFeed</a></span>.</p>
          <p class="mb-5">However if you are still looking for more information then you can contact us through one of our preferred contact methods:</p>
          <p class="mb-5">Email:</p>
          <p class="mb-5">By visiting this link:</p>
          <p class="mb-5">Phone:</p>
        </vx-card>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "CookiePolicy"
  }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }

  section {
    padding: 10rem;
    background: #FFFFFF;
    position: relative;
  }
  section p, section ul li{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 26px;
    color: #848199;
  }

  .leaf-2 {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .leaf-1 {
    position: absolute;
    right: 0;
    top: 0;
    width: 800px;
  }

  .section__h3 {
    margin-top: 5rem!important;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 28px;
    text-align: center;
    color: #231D4F;
  }
  .section__p {
    margin-bottom: 5rem!important;
    width: 80%;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    /* or 150% */
    text-align: center;
    color: #848199;
  }
  .truncate {
    width: 80%;
    white-space: normal !important;
    margin-left: 1.5rem;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 10rem 2rem;
      background: #FFFFFF;
    }
    .section__p {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .leaf-1, .leaf-2 {
      width: -webkit-fill-available;
      width: -moz-available;
    }
  }
</style>
